import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import { sparkplugAppletNodeCfgDeployParamSchema } from '../../sparkplug-node-cfg.zod';
import { DEFAULT_CONNECTION_ID } from '../../../../../connections/connection-config';

const metricExpressionsSchema = z.array(z.object({
    name: z.string(),
    /**
     * `varValue` type is the default for legacy configs
     */
    dataType: z.union([ z.literal('string'), z.literal('number'), z.literal('boolean'), z.literal('varValue') ]),
}));

type MetricExpressions = z.infer<typeof metricExpressionsSchema>;

export const sparkplugCommanderNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('sparkplugCommander'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        connectionId: z.string().default(DEFAULT_CONNECTION_ID),
        configDeploymentParameter: sparkplugAppletNodeCfgDeployParamSchema,
        metricExpressions: z.union([
            z.array(z.string()).transform(arr => arr.map(name => ({ name, dataType: 'varValue' as const }))),
            metricExpressionsSchema,
        ]) as z.ZodType<MetricExpressions>,
    })),
}));
export type SparkplugCommanderNodeCfgSchema = z.infer<typeof sparkplugCommanderNodeCfgSchema>;

export const sparkplugCommanderNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ event: 'event' }),
    },
    dataSockets: {
        inputs: cfg => {
            const ret: Record<`input${number}`, 'string' | 'number' | 'boolean' | 'varValue'> = {};
            cfg.controlValues.metricExpressions.forEach((m, idx) => {
                ret[`input${idx}`] = m.dataType;
            });
            return ret;
        },
        outputs: () => ({}),
    },
} satisfies NodeSocketCfg<SparkplugCommanderNodeCfgSchema>;
